<template>
  <!-- #ifdef MP-WEIXIN -->
  <InnerMatchPersonInfo
    v-if="show"
    :head="head"
    :nick="nick"
    :tips="tips"
    :title="title"
    @clickBack="clickBack"
    @clickConfirm="clickConfirm"
  />
  <!-- #endif -->
  <!-- #ifdef MP-QQ || H5 -->
  <InnerMatchPersonInfoWeb
    v-if="show"
    :head="head"
    :nick="nick"
    :tips="tips"
    :title="title"
    @clickBack="clickBack"
    @clickConfirm="clickConfirm"
  />
  <!-- #endif -->
</template>

<script>
// QQ小程序没有微信小程序的获取头像、昵称功能，需要用web的自定义
// #ifdef MP-WEIXIN
import InnerMatchPersonInfo from './person-info-mp';
// #endif
// #ifdef MP-QQ || H5
import InnerMatchPersonInfoWeb from './person-info-web';
// #endif
import { setUserInfo } from 'src/local-logic/tip-match/person-info';
import { getByteLen } from 'src/local-logic/tip-match/text';
export default {
  name: 'MatchPersonInfo',
  components: {
    // #ifdef MP-WEIXIN
    InnerMatchPersonInfo,
    // #endif
    // #ifdef MP-QQ || H5
    InnerMatchPersonInfoWeb,
    // #endif
  },
  props: {
  },
  data() {
    return {
      show: false,
      head: '',
      nick: '',
      tips: '',
      title: '',
    };
  },
  mounted() {

  },
  methods: {
    setData(data) {
      Object.keys(data).forEach((key) => {
        try {
          this[key] = data[key];
        } catch (err) {
        }
      });
    },
    showDialog(options) {
      this.show = true;
      if (options) {
        Object.keys(options).map((key) => {
          this[key] = options[key];
        });
      }
    },
    clickBack() {
      this.$emit('clickBack');
      this.show = false;
    },
    clickConfirm({ head, nick }) {
      if (!this.check(head, nick)) {
        return;
      }
      this.showLoading();
      setUserInfo({
        head,
        nick,
      })
        .then(() => {
          this.$emit('clickConfirm');
          this.show = false;
          // 后台有延迟，等一小会再刷新
          setTimeout(() => {
            // 小程序页面loading无法消失，需要前端重新触发下
            // window.location.reload();
            this.$ebus?.emit('refreshMine');
            this.dismissLoading();
          }, 800);
        })
        .catch(() => {
          // 避免冲掉错误信息
          setTimeout(() => {
            this.dismissLoading();
          }, 1500);
        })
        .finally(() => {
        });
    },
    check(head, nick) {
      const nickLength = getByteLen(nick?.trim());
      if (nickLength <= 0 || nickLength > 32) {
        this.showToast('请输入正确的昵称');
        return false;
      }
      if (head?.trim()?.length <= 0) {
        this.showToast('请设置头像');
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
</style>
